// src/components/AdminAddAffiliate.jsx
import React, { useState, useEffect, useRef } from 'react';
import '../App.css';
import { useLocation, useNavigate } from 'react-router-dom';
import { Form, FormGroup, Button, Input, Label } from 'reactstrap';
import MyStorage from './util/storage';
import { Oval as Loader } from 'react-loader-spinner';
import moment from 'moment';
import { ToastContainer } from 'react-toastify';
import showToast from './util/toast';
import { db1, storage1 } from '../../firebase/firebase1';
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { EditorState, ContentState, convertToRaw, convertFromHTML } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import add from '../assets/add.png';
import cross from '../assets/delete.png';
import Resizer from 'react-image-file-resizer';

const slugify = (text = '') => {
  return text.toString().toLowerCase().trim()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '');
};

const AddAffiliate = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const model = location.state?.model;
  const editMode = model != null;

  const [id, setId] = useState(editMode ? model.id : '');
  const [title, setTitle] = useState(editMode ? model.title : '');
  const [details, setDetails] = useState(editMode ? model.details : '');
  const [amazonLink, setAmazonLink] = useState(editMode ? model.amazonLink : '');
  const [price, setPrice] = useState(editMode ? model.price : '0');
  
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const [images, setImages] = useState([{}]);
  const addScreenshot = useRef(null);
  const [loader, setLoader] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (editMode) {
      if (model.body) {
        const blocksFromHTML = convertFromHTML(model.body);
        const contentState = ContentState.createFromBlockArray(
          blocksFromHTML.contentBlocks,
          blocksFromHTML.entityMap
        );
        setEditorState(EditorState.createWithContent(contentState));
      }

      let imgs = [{}];
      for (let j = 0; j < (model.images || []).length; j++) {
        imgs = imgs.concat({ file: null, url: model.images[j], name: '' });
        if (j === model.images.length - 1) setImages(imgs);
      }
    }
  }, []);

  if (!MyStorage.isLogin()) {
    navigate('/admin/login', { replace: true });
    return null;
  }

  const onEditorStateChange = (state) => setEditorState(state);

  const resizeFile = (file) => new Promise(resolve => {
      Resizer.imageFileResizer(file, 1024, 1024, 'JPEG', 90, 0,
          uri => {
              resolve(uri);
          }, 'file');
  });

  const handleAddImage = async (event) => {
    let temp = [{}];
    for (let i = 0; i < event.target.files.length; i++) {
      const file = event.target.files[i];
      const resizedImage = await resizeFile(file);
      let url = URL.createObjectURL(resizedImage);
      temp = temp.concat({ file: resizedImage, url: url, name: resizedImage.name });
    }
    setImages(temp);
  };

  const showImages = () => images.map((item, index) => {
    if (index === 0) {
      return (
        <div style={{ marginRight: 10, marginBottom: 10 }} key={index}>
          <div onClick={() => addScreenshot.current.click()} style={{ width: 100, height: 100, backgroundColor: 'gray', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <img src={add} style={{ width: 30, height: 30 }} />
            <input multiple type='file' style={{ display: 'none' }} ref={addScreenshot} onChange={handleAddImage} />
          </div>
        </div>
      );
    }
    return (
      <div key={index} style={{ display: 'inline-flex', width: 100, height: 100, marginRight: 10, marginBottom: 10 }}>
        <img src={item.url} style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
        <div onClick={() => {
          const temp = images.filter((_, j) => index !== j);
          setImages(temp);
        }} style={{ width: 25, height: 25, marginLeft: -25, marginTop: 0, backgroundColor: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <img src={cross} style={{ width: 20, height: 20 }} />
        </div>
      </div>
    );
  });

  const saveProduct = () => {
    if (saving) return;
    if (!title || !price || !amazonLink) {
      showToast('error', 'Please fill all required fields!');
      return;
    }

    const bodyHtml = draftToHtml(convertToRaw(editorState.getCurrentContent()));
    setLoader(true);
    setSaving(true);
    uploadImagesAndSave(bodyHtml);
  };

  const uploadImagesAndSave = (bodyHtml) => {
    const newImages = images.filter(img => img.file);
    const existingUrls = images.filter(img => !img.file && img.url).map(img => img.url);

    if (newImages.length === 0) {
      saveToFirebase(bodyHtml, existingUrls);
      return;
    }

    let uploadedUrls = [];
    let index = 0;

    const uploadNext = () => {
      const img = newImages[index];
      const path = `products/${img.name || img.file.name}`;
      const uploadTask = storage1.ref(path).put(img.file);
      uploadTask.on('state_changed', null, console.error, () => {
        storage1.ref(path).getDownloadURL().then((url) => {
          uploadedUrls.push(url);
          if (index === newImages.length - 1) {
            const allUrls = existingUrls.concat(uploadedUrls);
            saveToFirebase(bodyHtml, allUrls);
          } else {
            index++;
            uploadNext();
          }
        });
      });
    };

    uploadNext();
  };

  const generateId = () => {
    if (id) return id;
    const t = slugify(title || 'affiliate');
    return `affiliate_${t}_${Date.now()}`;
  };

  const saveToFirebase = (bodyHtml, urls) => {
    const idToUse = editMode ? (model.id || generateId()) : generateId();

    const data = {
      id: idToUse,
      title,
      price,
      details,
      amazonLink,
      images: urls,
      body: bodyHtml,
      added_date: Number(moment().valueOf())
    };

    const collection = db1.collection('products');
    if (editMode) {
      collection.doc(model.id).set(data, { merge: true })
        .then(() => {
          setSaving(false);
          setLoader(false);
          showToast('success', 'Affiliate product updated!'); 
          navigate(-1);
        })
        .catch(() => {
          setSaving(false);
          showToast('error', 'Failed!');
          setLoader(false);
        });
    } else {
      collection.doc(idToUse).set(data)
        .then(() => {
          setSaving(false);
          setLoader(false);
          showToast('success', 'Affiliate product added!');
          navigate(-1);
        })
        .catch(() => {
          setSaving(false);
          showToast('error', 'Failed!');
          setLoader(false);
        });
    }
  };

  return (
    <div className='main'>
      <div className='titlebar' style={{ backgroundColor: '#f2f2f2', padding: 10, margin: -15 }}>
        <div style={{ color: 'blue' }}>{editMode ? 'Edit Affiliate Product' : 'Add Affiliate Product'}</div>
      </div>

      <div style={{ width: '100%', display: 'flex', flexDirection: 'column', padding: 0 }}>
        <div style={{ paddingTop: 30, paddingBottom: 100, display: 'flex', flexDirection: 'column', alignItems: 'center', height: '100vh', overflow: 'scroll' }}>
          <Form className='form' style={{ padding: 0, backgroundColor: '#f2f2f2', borderRadius: 10, minWidth: 600 }}>

            <FormGroup>
              <div style={{ color: 'gray' }}>Title *</div>
              <Input type='text' placeholder='' value={title} onChange={e => setTitle(e.target.value)} />
            </FormGroup>
            
            <FormGroup>
              <div style={{ color: 'gray' }}>Price *</div>
              <Input type='text' placeholder='e.g. 19.99' value={price} onChange={e => setPrice(e.target.value)} />
            </FormGroup>
            
            <FormGroup>
              <div style={{ color: 'gray' }}>Details</div>
              <Input type='textarea' placeholder='Short details...' value={details} onChange={e => setDetails(e.target.value)} />
            </FormGroup>

            <FormGroup>
              <div style={{ color: 'gray' }}>Amazon Buy Link *</div>
              <Input type='text' placeholder='https://amazon.com/...' value={amazonLink} onChange={e => setAmazonLink(e.target.value)} />
            </FormGroup>

            <FormGroup>
              <div style={{ color: 'gray' }}>Body (Description)</div>
              <Editor
                editorStyle={{ backgroundColor: '#fafafa', paddingLeft: 10, paddingRight: 10, height: 150 }}
                editorState={editorState}
                onEditorStateChange={onEditorStateChange}
              />
            </FormGroup>

            <FormGroup>
              <div>Images:</div>
              <div style={{ display: 'flex', flexWrap: 'wrap', marginTop: 5 }}>
                {showImages()}
              </div>
            </FormGroup>

            <Button
              className='btn-block btn-dark'
              style={{ marginTop: 15, marginBottom: 40, fontSize: 18, fontWeight: 'bold', width: '100%', backgroundColor: 'orange', borderWidth: 0, height: 50 }}
              onClick={saveProduct}>
              {editMode ? 'Update Affiliate Product' : 'Save Affiliate Product'}
            </Button>
          </Form>
        </div>
      </div>

      {loader &&
        <div style={{ position: 'absolute', display: 'flex', flex: 1, alignItems: 'center', justifyContent: 'center', height: '80%', width: '80%' }}>
          <Loader type="ThreeDots" color="white" height={70} width={70} visible={true} />
        </div>
      }

      <ToastContainer />
    </div>
  );
};

export default AddAffiliate;
